import React 			from 'react';
import PropTypes 		from 'prop-types';
import ReactDOM 		from 'react-dom';
import update 			from 'react-addons-update';
import BLComponent		from '../core/_BLComponent.jsx';

import StudioModel		from '../studio/StudioModel.jsx';
import LikeButton		from './_LikeButton.jsx';
import {AwardIcon}		from './_Icons.jsx';
import {CustomAlert}	from '../common/_Utilities.jsx';

export default class MocCard extends BLComponent 
{
	constructor (props) 
	{
		super(props);

		this.state = 
			{
				likes: 	{
							count: this.props.data.likes.count
						,	liked: this.props.data.likes.liked
						}
			};

		this._callbackRegistered	= null;
	}

	componentDidMount() 
	{
		this.fetchPersonalizeData();
		blapp.session.onSessionUpdate( this.onSessionUpdate );
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}

	render() 
	{
		const {classes = '', data, withIconBackground = false} = this.props;
		const badges = this.props.awards;
		let userAward = data.user.award;

		let awards = [];

		badges && badges.length > 0 && badges.forEach(badge => {
			awards.push(<AwardIcon source={'card'} award={badge} background/>)
		})

		if(data.staffPickAward > 0) {
			awards.push(<AwardIcon source={'card'} award={data.staffPickAward} background/>);
		}

		return (
			<article className={"card moc-card " + classes}>
				<div className="card__internal moc-card__internal" data-ts-name="moc-card" data-ts-id={data.id} data-ts-key={this.props.key}>
					<a href={blapp.url2.getStudioPublicGalleryUrl(data.user.id)} className="moc-card__designer" data-ts-name="moc-card__link">
						<div className="moc-card__designer-profile">
							<div className="moc-card__designer-image">
								<img src={data.user.image} className="moc-card__designer-image-content"/>
							</div>
							{userAward > 0 ? <div className="moc-card__designer-award"><AwardIcon source={'card'} award={userAward} background/></div> : null}
						</div>
						<header className="moc-card__designer-details">
							<div className="moc-card__designer-name">{data.user.name}</div>
							<div className="moc-card__designer-creations">{`${data.user.creations} ${data.user.creations > 1 ? 'creations' : 'creation'}`}</div>
						</header>
					</a>
					<div onClick={() => this.showModelDetail()} className="moc-card__image" style={{paddingTop: (data.imgHeight / data.imgWidth) * 100 + '%'}}>
						<a href={blapp.url2.getStudioModelUrl(data.id)} onClick={(e) => e.preventDefault()} className="moc-card__image-internal" data-ts-name="moc-card__link"><img src={data.image} className="moc-card__image-content"/></a>
					</div>
					<footer className="moc-card__footer">
						<a href={blapp.url2.getStudioModelUrl(data.id)} onClick={(e) => {this.showModelDetail(); e.preventDefault()}} className="moc-card__name" data-ts-name="moc-card__link">
							{data.name}
						</a>
						{awards.length ?
							<div className="moc-card__moc-award">
								{this.renderAwards(awards)}
							</div>
						: null}
						<div className="moc-card__footer-actions">
							{data.downloadable ? <i className="moc-card__downloadable fas fa-download text-color--white" /> : null}
							<LikeButton classes="moc-card__likes" likes={this.state.likes} onClickFunc={() => this.toggleLike()}/>
						</div>
					</footer>
				</div>
			</article>
		);
	}

	renderAwards(awards) {
		if(awards.length > 2) {
			return (
				<React.Fragment>
					{awards[0]}
					<div className="award-icon award-icon--multiple-awards">
						+{awards.length - 1}
					</div>
				</React.Fragment>
			);
		}else{
			return (
				<React.Fragment>
					{awards}
				</React.Fragment>
			);
		}
	}

	fetchPersonalizeData()
	{
		if ( this._callbackRegistered == null )
			this._callbackRegistered	= this.updatePersonalizedData;
		blapp.personalized.fetchPersonalizedDataForModel( this.props.data.id, this.updatePersonalizedData);
	}

	updatePersonalizedData = ( data ) => 
	{
		if ( data && data.dataModel )
		{
			const likes = update(this.state.likes, {liked: {$set: data.dataModel.bIsLiked}});
			this.setState( { likes: likes } );
		}
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	toggleLike()
	{
		const me = blapp.session.getMe();
		if( me == null )
		{
			blapp.refs.get("header").showLogin(
				() =>
				{
					if( blapp.session.isLoggedIn())
					{
						this.doToggleLike();
					}
				}
			);
			return;
		}
		else{
			this.doToggleLike();
		}
	}

	doToggleLike() 
	{
		const likes = this.state.likes;
		blapp.models.fetch
		(
			"_toggleLike"
		,	{
				controller:	"studio.BLCUserModel"
			,	method:		"toggleLike"
			,	params:		[ this.props.data.id ]
			,	refresh:	true
			}
		).then(
        	(data) =>
            {
				if(data !== null){
					likes.liked = data;
					data == 0 ? likes.count-- : likes.count++; 
					this.setState({likes: likes})
				}
				else{
					this.triggerAlert('Error performing action')
				}
				
            }
        ).catch( 
        	() =>
            {
				this.triggerAlert( 'Error performing action' )
            }
        );
	}

	showModelDetail()
	{
		blapp.screen.showModal( <StudioModel referer={this.props.referer} idModel={this.props.data.id} close={blapp.screen.closeModal} func={{ setSearch: this.props.func.setSearch }}/> );
	}

	onSessionUpdate = () =>
	{
		if ( blapp.session.isLoggedIn() )
		{
			this.fetchPersonalizeData();
		}
		else
		{
			this.setState( { likes: { liked: false, count: this.state.likes.count } } );
		}

	}

	static getDataFromModel( model )
	{
		const today = new Date();
		const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
		const pastDate = lastWeek.getTime();
		const staffPickAward = (model.bStaffPicked &&  model.udtStaffPicked >= pastDate) ? 5 
			: (model.bStaffPicked && model.udtStaffPicked < pastDate) ? 4 : null;
		const pendingModeration = model.nModerateAction == 0 && model.nPreviousAccess != 0;
		return	{
					id:		model.idModel
				,	image:	model.dmMainThumb ? model.dmMainThumb.url : model.dmMainImage ? model.dmMainImage.url : null
				,	name:	model.strModelName
				,	url:	blapp.url2.getStudioModelUrl(model.idModel)
				,	likes:	{
								liked:	false
							,	count:	model.nLikesCnt
							}
				,	downloadable: model.bDownloadable && !pendingModeration		
				,	imgWidth:	model.nImageWidth != 0 ? model.nImageWidth : 331
				,	imgHeight:	model.nImageHeight != 0 ? model.nImageHeight : 248
				,	staffPickAward: staffPickAward
				,	user:	{
								id:			model.dmUserBuilder.dmUser.idUser
							,	name:		model.dmUserBuilder.dmUser.skUsername
							,	image:		blapp.url2.getProfileImgUrl(model.dmUserBuilder.dmUser,'small')
							,	creations:	model.dmUserBuilder.stats.nPublicCreations
							,	award:		model.dmUserBuilder.stats.nTypeBadge
							}
				}
	}
};

MocCard.propTypes = {
		classes: PropTypes.string
	,	withIconBackground: PropTypes.boolean
	,	data: PropTypes.shape({
				id: PropTypes.number.isRequired
			,	image: PropTypes.string.isRequired
			,	name: PropTypes.string.isRequired
			,	url: PropTypes.string.isRequired
			,	downloadable: PropTypes.boolean
			,	likes: PropTypes.shape({
					liked: PropTypes.boolean
				,	count: PropTypes.number.isRequired
			,	imgWidth: PropTypes.number.isRequired
			,	imgHeight: PropTypes.number.isRequired
			}).isRequired
			,	user: PropTypes.shape({
						id: PropTypes.number.isRequired
					,	name: PropTypes.string.isRequired
					,	image: PropTypes.string.isRequired
					,	creations: PropTypes.number.isRequired
				})
		}).isRequired
}